var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-stat"},[_c('h4',{staticClass:"single-stat__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"single-stat__value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }